/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, TextField, MenuItem } from '@material-ui/core';
import { Button } from 'react-bootstrap';

import { uniqBy } from 'lodash';
import moment from 'moment';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import {
  GetAllRebateDropdown,
  getCheckAllocationComparision,
  getCheckPayeeCode,
  setCheckAllocationData,
  setSearchInput,
} from '../Store/actions';
import {
  autoFormateDate,
  tabHighLigther,
  validateDateQuarter,
} from '../../../../SharedModules/utilities/utilities';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import {
  validateDate,
  compareDate,
} from '../../../../SharedModules/utilities/dateUtilities';

import { quarterToDate } from '../Utility';
import {
  CHECK_PAYEE_NOT_NULL,
  END_DATE_GREATER_THAN_START_DATE_FOR_CONTRACT,
  FROM_DATE_QTR_REQUIRED,
  INVALID_DATE_DURATION,
  TO_DATE_QTR_REQUIRED,
} from '../../../../SharedModules/Errors/constantMessageData';
import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';
import {
  handleScrollToEvent,
  redirectURLLink,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';

const CheckAllocationComparisionSearch = (props) => {
  const dispatch = useDispatch();
  const {
    checkPayeeCode,
    checkPayValue,
    displayOptionValue,
    fromDateValue,
    toDateValue,
    allErrors,
    checkAllocationComparisionData,
    isLoading,
  } = useSelector(
    (state) => state?.sharedState?.CheckAllocationComparisionReducer
  );
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );

  const [checkPay, setCheckPayee] = React.useState(checkPayValue);
  const [displayOption, setDisplayOption] = React.useState(displayOptionValue);
  const [fromDate, setFromDate] = React.useState(fromDateValue);
  const [toDate, setToDate] = React.useState(toDateValue);
  const [errorList, setErrorList] = React.useState(allErrors);
  const [searchClicked, setSearchClicked] = React.useState(false);
  React.useEffect(() => {
    dispatch(getCheckPayeeCode());
    handleScrollToEvent();
  }, []);
  React.useEffect(() => {
    dispatch(setSearchInput({ allErrors: [] }));
    setCheckPayee(checkPayValue || userDefaults?.checkPayeeCd);
  }, [checkPayeeCode]);
  // tabhighlighet component help in highlighting tab base on error the screen
  React.useEffect(() => {
    if (errorList.length > 0) {
      tabHighLigther('/checkallocationcomparison', true);
    } else {
      tabHighLigther('/checkallocationcomparison', false);
    }
  }, [JSON.stringify(errorList)]);
        
  //remove no data error msg
  React.useEffect(() => {
    dispatch(setSearchInput({ allErrors: [] }));
  }, [toDate, fromDate, checkPayeeCode, checkPay, displayOption]);

  // function to validate from Date and toDate on onblur
  const handleOnBlur = (type, input) => {
    dispatch(setSearchInput({ allErrors: [] }));
    const value = autoFormateDate(input.toUpperCase());
    let allErrors = errorList;
    let fromError = [];
    let toError = [];
    if (type === 'fromDate') {
      setFromDate(value.toUpperCase());
      if (!value)
        fromError = [{ field: 'fromDate', message: FROM_DATE_QTR_REQUIRED }];
      else if (validateDateQuarter(value, 'fromDate')?.length)
        fromError = validateDateQuarter(value, 'fromDate');
      allErrors = [...allErrors, ...fromError];
      if (!toDate && !fromError.length) setToDate(value.toUpperCase());
    }
    fromError = allErrors.filter((item) => item.field === 'fromDate');
    if (type === 'toDate') {
      if (!value)
        toError = [{ field: 'toDate', message: TO_DATE_QTR_REQUIRED }];
      setToDate(value.toUpperCase());
      if (value.trim().length > 0)
        toError = validateDateQuarter(value, 'toDate');

      allErrors = [...allErrors, ...toError];
    }
    if (value.trim().length > 0) {
      toError = allErrors.filter((item) => item.field === 'toDate');
    }

    if (fromError.length === 0 && toError.length === 0) {
      allErrors = allErrors.filter(
        (error) =>
          error.field !== 'toDate' &&
          // error.field !== 'fromDate' &&
          error.field !== 'fromDate>toDate'
      );
      let frmDt, toDt;
      if (type === 'fromDate' && value) frmDt = value;
      else frmDt = fromDate;
      if (type === 'toDate' && value) toDt = value;
      else toDt = toDate;
      if (compareDate(frmDt, toDt)) {
        allErrors.push({
          field: 'fromDate>toDate',
          message: END_DATE_GREATER_THAN_START_DATE_FOR_CONTRACT.replace(
            'End Date',
            'To Date/Quarter'
          ).replace('Start Date', 'From Date/Quarter'),
        });
      } else if (moment(toDate).diff(moment(fromDate), 'years') > 0) {
        allErrors.push({
          field: 'fromDate>toDate',
          message: INVALID_DATE_DURATION,
        });
      }
    }
    setErrorList(allErrors);
  };

  useEffect(() => {
    setErrorList(allErrors);
  }, [allErrors]);

  // This Function handles the validation nad if all good navigate to display screen
  const handleSearchClick = () => {
    dispatch(setSearchInput({ allErrors: [] }));
    const allErrors = [];
    if (checkPay === '-1' || checkPay === null || checkPay === undefined) {
      allErrors.push({
        field: 'checkPayee',
        message: CHECK_PAYEE_NOT_NULL,
      });
    }
    const fromError = validateDateQuarter(fromDate, 'fromDate');
    let toError = [];

    if (toDate.trim().length) {
      toError = validateDateQuarter(toDate, 'toDate');
    }
    const existingError = errorList.filter(
      (error) =>
        error.field !== 'fromDate' &&
        error.field !== 'toDate' &&
        error.field === 'fromDate>toDate'
    );
    if (
      toDate.trim().length > 0 &&
      fromError.length === 0 &&
      toError.length === 0
    ) {
      if (compareDate(fromDate, toDate)) {
        allErrors.push({
          field: 'fromDate>toDate',
          message: END_DATE_GREATER_THAN_START_DATE_FOR_CONTRACT.replace(
            'End Date',
            'To Date'
          ).replace('Start Date', 'From Date/Quarter'),
        });
      }
    }
    const allErr = [...allErrors, ...existingError, ...fromError, ...toError];
    if (allErr.length>0){
      dispatch(setSearchInput({allErrors:allErr}))
      setErrorList(allErr)
      return
    }
    dispatch(
      setSearchInput({
        checkPayValue: checkPay,
        displayOptionValue: displayOption,
        fromDateValue: fromDate,
        toDateValue: toDate,
        allErrors: allErr,
        displayObj: {
          checkPayValue: checkPay,
          displayOptionValue: displayOption,
          fromDateValue: fromDate,
          toDateValue: toDate,
          checkPayeeCode,
        },
      })
    );
    setErrorList(allErr);
    if (allErr.length === 0) {
      setSearchClicked(true);
      dispatch(setCheckAllocationData([]));
      if (!toDate) {
        setToDate(fromDate);
      }

      const fetchData = async () => {
        try {
          await Promise.all([
            dispatch(
              getCheckAllocationComparision({
                checkpayee: checkPay.split('-')[0],
                begindate: quarterToDate(fromDate),
                enddate:
                  quarterToDate(toDate, 'toDate') || quarterToDate(fromDate),
              })
            ),
            dispatch(GetAllRebateDropdown()),
          ]);
        } catch (error) {}
      };

      fetchData();
    }
  };
  if (searchClicked && checkAllocationComparisionData.length > 0) {
    setSearchClicked(false);
    redirectURLLink(
      '/checkallocationcomparisiondispaly',
      'Check Allocation Comparision Display',
      props.history
    );
    dispatch(clearReduxForFilterAndSort('/checkallocationcomparisiondispaly'));
  }

  // Calling the API for get report data
  let errorMessageList = errorList.map((item) => {
    if (item.field == 'fromDate') {
      return {
        ...item,
        message: item.message
          ?.replace('date', 'From Date/Quarter')
          ?.replace('As Of Date', 'From Date/Quarter')
          ?.replace('  As Of From', 'From Date/Quarter'),
      };
    }
    if (item.field == 'toDate') {
      return {
        ...item,
        message: item.message
          ?.replace('date', 'To Date/Quarter')
          ?.replace('As Of Date', 'To Date/Quarter'),
      };
    }
    return item;
  });
  errorMessageList = uniqBy(errorMessageList, 'field');
  return (
    <div className='tabs-container'>
      <CustomSeparator
        parent1='Detail Reports'
        parent2='Check/Allocation Comparison'
      />
      <Spinner load={isLoading} />
      <DisplayErrorMessages
        errorMessages={[...new Set(errorMessageList.map((l) => l.message))]}
      />
      <div className='tab-body'>
        <div className='row' style={{ marginTop: 15 }}>
          <div className='col-4'>
            <fieldset className='custom-fieldset'>
              <legend className='same-font-family'>
                Check Payee <span className='mandatory'> *</span>
              </legend>
              <div className='form-wrapper no-lbl'>
                <div className='mui-custom-form with-select'>
                  <TextField
                    data-testid='rebate_program-generate-inv'
                    id='checkPayee'
                    // className="frr-display-hidden-label"
                    label='Checks for Payee'
                    fullWidth
                    select
                    required
                    placeholder=''
                    inputProps={{ maxLength: 11, id: 'checkPayee' }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={checkPay}
                    onChange={(e) => {
                      setCheckPayee(e.target.value);
                      const errorMsg = [...errorList];
                      if (
                        e.target.value === '-1' ||
                        e.target.value === null ||
                        e.target.value === undefined
                      ) {
                        errorMsg.push({
                          field: 'checkPayee',
                          message: CHECK_PAYEE_NOT_NULL,
                        });
                        setErrorList(errorMsg);
                      } else {
                        setErrorList([
                          ...errorList.filter(
                            (error) => error.field !== 'checkPayee'
                          ),
                        ]);
                      }
                    }}
                    className='frr-display-hidden-label mandate-fields '
                    helperText={
                      errorList.find((error) => error.field === 'checkPayee')
                        ?.message
                    }
                    error={
                      errorList.find((error) => error.field === 'checkPayee')
                        ?.message
                    }
                  >
                    <MenuItem
                      key=''
                      value='-1'
                      className='frr-dropdown-blank-item'
                    />

                    {checkPayeeCode?.map((item) => {
                      return (
                        <MenuItem
                          key={item.codeValueID && item.codeValueID.codeValue}
                          value={item.codeValueID && item.codeValueID.codeValue}
                        >
                          {`${
                            item.codeValueID && item.codeValueID.codeValue
                          } - ${item.shortDescription}`}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                </div>
              </div>
            </fieldset>
          </div>
          <div className='col-4'>
            <fieldset className='custom-fieldset'>
              <legend className='same-font-family'>
                Date/Quarter Range <span className='mandatory'> *</span>{' '}
              </legend>
              <div className='form-wrapper p-0 mt-n3'>
                <div className='mui-custom-form input-md field-xl'>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <TextField
                        label='From Date/Quarter'
                        id='From Date'
                        placeholder=''
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{ maxLength: 10 }}
                        name='From'
                        value={fromDate}
                        error={
                          errorList.filter(
                            (error) => error.field === 'fromDate'
                          )?.length > 0
                            ? true
                            : false
                        }
                        data-testid='checkAllocation-fromdate-from'
                        className='mandate-fields'
                        onChange={(e) => {
                          setFromDate(e.target.value.toUpperCase());
                          setErrorList([
                            ...errorList.filter(
                              (error) => error.field !== 'fromDate'
                            ),
                          ]);
                        }}
                        helperText={errorList
                          .find((error) => error.field === 'fromDate')
                          ?.message?.replace('date', 'From Date/Quarter')
                          ?.replace('As Of Date', 'From Date/Quarter')}
                        onBlur={(e) => handleOnBlur('fromDate', e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        label='To Date/Quarter'
                        id='To Date'
                        placeholder=''
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{ maxLength: 10 }}
                        name='to'
                        data-testid='checkAllocation-Todate-to'
                        value={toDate}
                        onChange={(e) => {
                          setToDate(e.target.value.toUpperCase());
                          setErrorList([
                            ...errorList.filter(
                              (error) =>
                                !['toDate', 'fromDate>toDate'].includes(
                                  error.field
                                )
                            ),
                          ]);
                        }}
                        onBlur={(e) => handleOnBlur('toDate', e.target.value)}
                        error={
                          errorList.filter(
                            (error) =>
                              error.field === 'toDate' ||
                              error.field === 'fromDate>toDate'
                          )?.length > 0
                            ? true
                            : false
                        }
                        helperText={errorList
                          .find(
                            (error) =>
                              error.field === 'toDate' ||
                              error.field === 'fromDate>toDate'
                          )
                          ?.message?.replace('date', 'To Date/Quarter')
                          ?.replace('As Of Date', 'To Date/Quarter')}
                        className='mandate-fields'
                      />
                    </Grid>
                  </Grid>
                </div>
              </div>
            </fieldset>
          </div>
          <div className='col-4 frr-two-col-radio'>
            <RadioGroupComponent
              data-testid='checkAllocation-totals-details'
              id='filter-plan-by-radio-btn-action'
              labelName='Display Options'
              required
              optionList={[
                {
                  name: 'Totals',
                  value: 'Totals',
                },
                {
                  name: 'Detail',
                  value: 'Detail',
                },
              ]}
              defaultValue={displayOption}
              filterAction={(value) => {
                setDisplayOption(value);
              }}
              className='log-batch-filter-radio frr-checkInvoiceRadio'
            />
          </div>
        </div>
        <div className='row' style={{ marginTop: 30 }}>
          <div className='btn-wrapper col-12'>
            <Button
              data-testid='checkAllocation-searchbtnclick'
              onClick={handleSearchClick}
              className='btn btn-success btn-search float-right'
            >
              <SVGComponent iconName='Icon-search' /> Search
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CheckAllocationComparisionSearch;
